import * as React from 'react';
import { Textarea, HiddenInput, Modal, ModalBody, ModalFooter, ModalSize, CustomButton, ButtonType, CustomSubmitButton, AlertMessage, AlertType, Form } from "soprasteria-ui-library";
import { IReferralResponseModel } from '../../../../../models/IReferral';
import { useAuth } from '../../../../../App';
import { ReferralResponseApi } from '../../../../../api/ReferralResponseApi';
import { setMessage } from '../../../../../helpers/MessageHelper';

interface IReferralComplementModal {
    referralId: number;
    onSuccess: (message: string) => void
}

export const ReferralComplementModal: React.FunctionComponent<IReferralComplementModal> = ({ referralId, onSuccess }) => {

    const api = new ReferralResponseApi(useAuth());
    const [errorMessage, setErrorMessage] = React.useState<string>();
    const [isApiPending, setIsApiPending] = React.useState<boolean>(false);
    const [renderForm, setRenderForm] = React.useState<boolean>(true);

    React.useEffect(() => {
        document.getElementById("open-referral-complement-modal")?.addEventListener('click', onOpenModalClick);

        return () => {
            document.getElementById("open-referral-complement-modal")?.removeEventListener('click', onOpenModalClick);
        }
    }, [])

    const onOpenModalClick = () => {
        setRenderForm(true);
    }

    const complementReferral = (data: IReferralResponseModel) => {
        setIsApiPending(true);
        api.complementReferral(data, () => {
            document.getElementById("close-referral-complement-modal")?.click();
            onSuccess("En begäran om komplettering har skickats");
        }, (error) => {
            const newMessage = setMessage(error, errorMessage ?? "");
            setErrorMessage(newMessage);
        }, () => setIsApiPending(false))
    }

    return (
        <Modal header="Begär komplettering" modalSize={ModalSize.large} id="referral-complement-modal">
            {
                renderForm
                    ?
                    <Form onSubmit={complementReferral}>
                        <ModalBody>
                            <AlertMessage alertType={AlertType.danger} duration={3000}>{errorMessage}</AlertMessage>
                            <HiddenInput name="referralId" value={referralId.toString()} />
                            <Textarea name="comment" label="Text till remittenten" rows={5} inlineLabel required />
                        </ModalBody>
                        <ModalFooter>
                            <CustomButton id="close-referral-complement-modal" buttonType={ButtonType.general} buttonText="Avbryt" data-dismiss="modal" onClick={() => setRenderForm(false)}/>
                            <CustomSubmitButton isLoading={isApiPending}>Begär komplettering</CustomSubmitButton>
                        </ModalFooter>
                    </Form>
                    : null
            }
        </Modal>
    )
}